export default __webpack_public_path__ + "static/media/ki.0e78a2ad.svg";